import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { data } from '../_models';

@Injectable({ providedIn: 'root' })
export class UserService {
    constructor(private http: HttpClient) { }

    getAll() {
        return this.http.get<data[]>(`/datas`);
    }

    register(data: data) {
        return this.http.post(`https://www.elchef.app/client/v1/register`, data);
    }

    delete(id: number) {
        return this.http.delete(`/datas/${id}`);
    }
}